<template>
  <div class="container-fluid mt-2">
    <h2>E-Mail Vorlagen</h2>
    <div class="btn-toolbar mt-3 justify-content-between" role="toolbar">
      <div class="wrapper">
        <button @click="addTemplate" class="btn btn-secondary mr-2"><font-awesome-icon icon="plus"/>&nbsp;Neu</button>
        <button @click="saveTemplate" class="btn btn-primary mr-2"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
        <button @click="deleteTemplate" class="btn btn-danger mr-2"><font-awesome-icon icon="trash"/>&nbsp;Löschen</button>
      </div>
      <div class="form-inline ml-2">
        <label>Bestell-Vorlagen:</label>
        <select v-model="activename" @change="selectTemplate(true)" class="form-control ml-2">
          <option value="">-</option>
          <option v-for="t in abtemplates" :key="t.map_id" :value="t.map_id">{{ t.title }}</option>
        </select>
      </div>
      <div class="form-inline ml-2">
        <label>Service-Vorlagen:</label>
        <select v-model="sractivename" @change="selectTemplate(false)" class="form-control ml-2">
          <option value="">-</option>
          <option v-for="t in srtemplates" :key="t.map_id" :value="t.map_id">{{ t.title }}</option>
        </select>
      </div>
      <div class="input-group ml-3">
        <div class="input-group-prepend">
          <div class="input-group-text">
            <input @change="updateEngine" type="checkbox" v-model="config['proxy.config.template.newengine']">
          </div>
        </div>
        <input type="text" class="form-control" value="Neue Templates aktiviert" disabled>
      </div>
    </div>
    <hr/>
    <div class="btn-toolbar mt-3" role="toolbar">
      <div class="form-inline">
        <label>Name:</label>
        <input type="text" v-model="template.title" class="form-control ml-2"/>
      </div>
      <div class="form-inline ml-2">
        <label>Typ:</label>
        <select v-model="template.type" class="form-control ml-2"><option value="1">AB-Mail</option><option value="2">Service Formular</option></select>
      </div>
      <div class="form-inline ml-2">
        <label>Sprache:</label>
        <select v-model="template.lang" class="form-control ml-2">
          <option value="*">default</option>
          <option value="de">deutsch</option>
          <option value="en">englisch</option>
          <option value="fr">französisch</option>
          <option value="nl">niederländisch</option>
        </select>
      </div>
      <div v-show="template.type == 2" class="form-inline ml-2">
        <label>Service-Vorlage:</label>
        <select v-model="srfieldbase" class="form-control">
          <option v-for="f in srtempnames" :key="f" :value="f">{{ f }}</option>
        </select>
      </div>
      <div class="form-inline ml-2">
        <label>Feld:</label>
        <div class="ml-2 input-group">
          <select v-model="selectedfield" class="form-control">
            <option v-for="f in docfields" :key="f" :value="f">{{ f }}</option>
          </select>
          <div class="input-group-append">
            <button @click="insertDocField" class="btn btn-primary"><font-awesome-icon icon="plus"/></button>
            <button @click="updateDocFields" class="btn btn-secondary"><font-awesome-icon icon="redo"/></button>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid mt-3">
      <div class="row">
        <div class="col-md border">
          <h3 class="mt-2">HTML Code</h3>
          <div class="wrapper" style="height:500px;">
            <AceEditor ref="editor" :editorId='"maileditor"' :lang="'xml'" :content="template.html"/>
          </div>
        </div>
        <div class="col-md border">
          <div class="row mt-2">
            <div class="pl-2 col-xs">
              <h3>Vorschau</h3>
            </div>
            <div class="col-md">
              <div class="btn-toolbar">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <button @click="updatePreview" class="btn btn-secondary"><font-awesome-icon icon="redo"/></button>
                  </div>
                  <input type="text" class="form-control" size="10" placeholder="Dokument-ID" v-model="previewID"/>
                </div>
              </div>
            </div>
          </div>
          <div class="wrapper border" id="previewOut">
          </div>
        </div>
      </div>
      <!-- <ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor> -->
    </div>
  </div>
</template>

<script>
import config from '@/modules/config.js'
import markup from '@/modules/markup.js'
import services from '@/modules/services.js'
import AceEditor from '@/components/AceEditor.vue'
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  name: 'EMailTemplates',
  components: {
    AceEditor
  },
  data() {
    return {
      abtemplates: [],
      srtemplates: [],
      activename: '',
      sractivename: '',
      template: {id:0,type:1,lang:'*',html:''},
      baseurl: config.baseUrl,
      updateiv: false,
      config: {},
      needs: ["proxy.config.template.newengine"],
      docfields: [],
      doctype: 1,
      selectedfield: '',
      srfieldbase: '',
      srtempnames: [],
      previewID:'',
    }
  },
  created: function() {
    var self = this;
    this.updateABTemplates();
    this.updateServiceTemplates();
    services.listtempnames(this,function(data) {
      self.srtempnames = data;
    })
    //this.updateiv = setInterval(this.checkUpdate.bind(this),3000);
    config.loadcfg(this.needs,this,function(data) {
      self.config = data;
    })
  },
  beforeDestroy: function() {
    if (this.updateiv) {
      clearInterval(this.updateiv);
    }
  },
  methods: {
    updateABTemplates() {
      var self = this;
      markup.list(this,1,function(data){
        self.abtemplates = data;
      })
    },
    updateServiceTemplates() {
      var self = this;
      markup.list(this,2,function(data) {
        self.srtemplates = data;
      })
    },
    saveTemplate: function() {
      var self = this;
      this.template.html = this.$refs.editor.getContent();
      markup.save(this,this.template,function(data) {
        self.template.map_id = data.map_id;
        self.$bvToast.toast('Vorlage gespeichert.',{title:'E-Mail Vorlagen',variant:'success'})
        if (self.template.type == 1)  {
          self.updateABTemplates();
        } else {
          console.log('update service list');
          self.updateServiceTemplates();
        }
      });
    },
    selectTemplate: function(type) {
      var tid = (type ? this.activename : this.sractivename);
      if (tid == '') return;
      var self = this;
      markup.load(this,tid,function(data) {
        self.template = data;
        self.$refs.editor.setContent(data.html);
        self.updatePreview();
      });
    },
    addTemplate: function() {
      console.log(JSON.stringify(this.abtemplates))
      this.template = {id:0,type:1,lang:'*',html:''};
      this.$refs.editor.setContent('');
    },
    deleteTemplate: function() {
      if (!this.template || !this.template.map_id || this.template.map_id == '') return;
      if (confirm('Möchten Sie das Template "' + this.template.title + '"wirklich löschen?')) {
        console.log('delete it');
        var self = this;
        var type = this.template.type;
        markup.delete(this,this.template.map_id,function() {
          self.$bvToast.toast('Vorlage gelöscht',{title:'E-Mail Vorlagen',variant: 'success'});
          if (type == 1) {
            self.updateABTemplates();
          } else {
            self.updateServiceTemplates();
          }
        })
      }
    },
    checkUpdate: function() {
      this.updatePreview();
    },
    updatePreview: function() {
      if (this.template.type == 2 && this.previewID == '') {
        this.$bvToast.toast('Bitte ein Beispiel Anfrage ID eingeben für die Vorschau.',{title:'Vorschau',variant:'warning'});
        return;
      }
      markup.livepreview(this,this.template.type,this.previewID,this.$refs.editor.getContent(),function(data) {
        document.getElementById('previewOut').innerHTML = data;
      })
    },
    updateEngine: function() {
      console.log('update');
      var self = this;
      config.savecfg(this.config,this,function() {
        self.$bvToast.toast('Einstellung aktualisiert',{title: 'Template Engine',variant: 'success'})
      })
    },
    readDocFields: function(prefix,obj) {
      for (var key in obj) {
        var entry = obj[key];
        if (typeof(entry) == "object") {
          this.readDocFields(prefix + key + '.',entry);
        } else {
          this.docfields.push(prefix + key);
        }
      }
    },
    updateDocFields: function() {
      var self = this;
      if (!this.template || !this.template.type) return;
      console.log('update fields');
      console.log(this.template.type);
      if (this.previewID !== '') {
        markup.previewjson(this,this.template.type,this.previewID,function(data) {
          self.docfields = [];
          self.readDocFields('',data);
        })
      } else {
        markup.previewjson(this,this.template.type,'',function(data){
          self.docfields = [];
          self.readDocFields('',data);
        });
      }
    },
    insertDocField: function() {
      console.log('insert field: ' + this.selectedfield);
      var prefix = this.template.type == 1 ? 'json_' : '';
      this.$refs.editor.insert('<span ts-template="set" name="' + prefix + this.selectedfield + '">' + this.selectedfield + '</span>');
    },
  }
}
</script>
